import { render, staticRenderFns } from "./sampleDialog.vue?vue&type=template&id=4b9b5e26&"
import script from "./sampleDialog.vue?vue&type=script&lang=js&"
export * from "./sampleDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports